"use client";

import { useEffect, useState } from "react";

/** Threshold past which a server-side wait is presented as background work. */
export const SLOW_PROCESSING_THRESHOLD_MS = 30_000;

/**
 * True once `active` has been continuously true for `thresholdMs`. Resets when `active` goes false.
 */
export function useSlowProcessing(
  active: boolean,
  thresholdMs: number = SLOW_PROCESSING_THRESHOLD_MS,
): boolean {
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    if (!active) return;
    const timer = window.setTimeout(() => setIsSlow(true), thresholdMs);
    // Reset on the way out, not in the effect body, so nothing sets state synchronously here.
    return () => {
      window.clearTimeout(timer);
      setIsSlow(false);
    };
  }, [active, thresholdMs]);

  return isSlow;
}
